export default __webpack_public_path__ + "static/media/vittaslogo.4123e296.svg";